export default "<!-- vue hook -->\n<!-- ko stopBinding: true -->\n<div id=\"vueForgotPassword\">\n  <forgot-password />\n</div>\n<!-- /ko -->\n";